<template>
  <v-card outlined>
    <chain-table-banner :table="table" @editChainTable="editChainTable" />

    <v-container class="pa-0" style="overflow-x: auto">
      <v-container
        :style="{
          minWidth: `${tableWidth + 'px'}`,
        }"
      >
        <chain-table-header :header="header" />
        <chain-table-row
          v-for="node in nodes"
          :key="node.id"
          :node="node"
          :table="table"
        />
      </v-container>
    </v-container>
  </v-card>
</template>

<script>
import ChainTableBanner from './ChainTableBanner.vue';
import ChainTableHeader from './ChainTableHeader.vue';
import ChainTableRow from './ChainTableRow.vue';

import { mapGetters } from 'vuex';

export default {
  components: {
    ChainTableBanner,
    ChainTableHeader,
    ChainTableRow,
  },
  props: {
    chain: {
      type: Object,
      default() {
        return {};
      },
    },
    table: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data: () => ({}),
  computed: {
    ...mapGetters(['getTableNodes', 'getTableHeader', 'getTableWidth']),
    header() {
      return this.table
        ? this.getTableHeader({
            chain: this.chain.id,
            module: this.table.module,
          })
        : [];
    },
    nodes() {
      return this.chain
        ? this.getTableNodes({ chain: this.chain, module: this.table.module })
        : [];
    },
    tableWidth() {
      return this.table
        ? this.getTableWidth({
            chain: this.chain.id,
            module: this.table.module,
          })
        : 474;
    },
  },
  methods: {
    editChainTable() {
      this.$emit('editChainTable', this.table);
    },
  },
};
</script>

<style></style>
